<template>
<v-row>
  <v-col cols="12" sm="12">
    <v-text-field label="* Descricao"
                  dense
                  :rules="[
                      this.$validators.string.required,
                           v => this.$validators.string.greaterThanOrEquals(v, 1),
                      v => this.$validators.string.lessThanOrEquals(v, 200)
                  ]"
                  v-model.trim="value.descricao"/>
  </v-col>
</v-row>
</template>

<script>
export default {
  name: "TipoContratoForm",
  props: {
    value: {
      type: Object
    }
  }
}
</script>

<style scoped>

</style>